import { useEffect, useState } from "react";
import { typography, utils, surfaces, buttons, colors } from "../../styles/index";

/**
 * Workspace-style page template
 * Robust mobile-collapsible sidebar (matchMedia-based)
 */
export default function WorkspacePageTemplate({
  title,
  actions,
  sidebar,
  children,
}) {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  /* ---------------------------
     Responsive detection (CORRECT)
  --------------------------- */
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleChange = (e) => {
      setIsMobile(e.matches);
    };

    // Initial value
    setIsMobile(mediaQuery.matches);

    // Listen for breakpoint changes
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  /* ---------------------------
     Sync sidebar state
  --------------------------- */
  useEffect(() => {
    // If we leave mobile, ensure sidebar overlay is closed
    if (!isMobile) {
      setSidebarOpen(false);
    }
  }, [isMobile]);

  return (
    <div style={{ ...utils.flexCol, gap: 24 }}>
      {/* Header */}
      <div style={utils.flexRow}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {isMobile && sidebar && (
            <button
              id="workspace-sidebar-toggle"
              style={{
                ...buttons.secondary,
                padding: "8px 12px",
              }}
              onClick={() => setSidebarOpen(true)}
              aria-label="Open menu"
            >
              ☰
            </button>
          )}

          <h1 style={typography.h2}>{title}</h1>
        </div>

        {actions}
      </div>

      {/* Main layout */}
      <div
        style={{
          display: "flex",
          gap: 24,
          alignItems: "flex-start",
        }}
      >
        {/* Desktop sidebar */}
        {!isMobile && sidebar && (
          <aside
            style={{
              width: 240,
              flexShrink: 0,
            }}
          >
            <div style={{ ...surfaces.card, padding: 12 }}>
              {sidebar}
            </div>
          </aside>
        )}

        {/* Content */}
        <section style={{ flex: 1, minWidth: 0 }}>
          {children}
        </section>
      </div>

      {/* Mobile sidebar overlay */}
      {isMobile && sidebar && sidebarOpen && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setSidebarOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.4)",
              zIndex: 999,
            }}
          />

          {/* Sidebar drawer */}
          <aside
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              width: 260,
              background: colors.white,
              zIndex: 1000,
              padding: 16,
              boxShadow: "2px 0 12px rgba(0,0,0,0.15)",
              overflowY: "auto",
            }}
          >
            <div style={{ marginBottom: 16 }}>
              <button
                style={buttons.secondary}
                onClick={() => setSidebarOpen(false)}
              >
                Close
              </button>
            </div>

            <div
              onClick={() => setSidebarOpen(false)}
              style={{ ...surfaces.card, padding: 12 }}
            >
              {sidebar}
            </div>
          </aside>
        </>
      )}
    </div>
  );
}
